var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcbo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1089 1551",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "docebo-logo-2021-0268d9-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #0268d9 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1080.5 0v1213.2c0 118.4 4.2 243.1 8.6 314.2h-290.6l-13-152.8h-6.4c-64.5 116.2-193.8 176.4-329.1 176.4c-249.9 0-450-213-450-539.9c-2.2-354.4 219.4-561.5 471.2-561.5c131.3 0 230.4 47.4 277.8 118.3h4.2v-567.9zm-327.3 920.6q0.2-7.5 0.1-15.1q-0.2-7.5-0.7-15.1q-0.5-7.5-1.4-15q-0.9-7.5-2.2-14.9c-4.3-22.1-12.4-43.3-23.9-62.7c-11.4-19.4-26.2-36.7-43.5-51.1c-17.3-14.4-37-25.7-58.2-33.4c-21.2-7.8-43.5-11.8-66-12c-150.7 0-226 133.2-226 299c0 178.6 88.3 290.4 223.9 290.4c22.5 0.1 44.8-3.6 65.9-11.1c21.2-7.5 40.9-18.6 58.2-32.8c17.4-14.3 32.1-31.4 43.6-50.7c11.5-19.2 19.5-40.4 23.8-62.4q1.6-9.3 2.8-18.6q1.3-9.3 2.1-18.7q0.8-9.4 1.1-18.8q0.4-9.4 0.4-18.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcbo);
export default __webpack_public_path__ + "static/media/DCBO.9ad4864be35fd865d2a1c3f7db44952a.svg";
export { ForwardRef as ReactComponent };